import React, { useContext } from 'react'
import { ReducerDispatchContext, ReducerContext } from '../reducers/reducerContext.js';
import CalculatorCriteria from '../components/calculator/CalculatorCriteria'
import helperCriteriaCalculator from '../helpers/HelperCriteriaCalculator';
import {
    fetchSimulationVehicleDetailsIfNeededCalculator, fetchCriteriaIfNeeded, fetchCriteriaOnParameterChangeIfNeeded
} from '../actions/actionsApiOffer.js'
import {
    setCalculatorCriteriaDuration, setCalculatorCriteriaMileage, setCalculatorCriteriaDeposit, setCalculatorCriteriaSvcMap,
    setCalculatorCriteriaProduct, setCalculatorCriteriaCustomer
} from '../actions/actionsAppCalculator'

export default function ContCalculatorCriteria(props) {
    const dispatch = useContext(ReducerDispatchContext);
    const globalstate = useContext(ReducerContext);

    function onChangeProduct(productKey) {
        dispatch(setCalculatorCriteriaProduct(productKey));
        fetchCriteriaIfNeeded(globalstate, dispatch, productKey);
    }
    function onChangeService(svcMap, settings) {
        dispatch(setCalculatorCriteriaSvcMap(svcMap));
        const serviceParameters = helperCriteriaCalculator.getServiceParameters(svcMap);
        fetchCriteriaOnParameterChangeIfNeeded(globalstate, dispatch, 'services', serviceParameters);
        fetchSimulationVehicleDetailsIfNeededCalculator(globalstate, dispatch, 'services', serviceParameters, settings);
    }
    function onChangeDuration(duration, settings) {
        dispatch(setCalculatorCriteriaDuration(duration));
        fetchCriteriaOnParameterChangeIfNeeded(globalstate, dispatch, 'duration', duration);
        fetchSimulationVehicleDetailsIfNeededCalculator(globalstate, dispatch, 'duration', duration, settings);
    }
    function onChangeMileage(mileage, settings) {
        dispatch(setCalculatorCriteriaMileage(mileage));
        fetchCriteriaOnParameterChangeIfNeeded(globalstate, dispatch, 'annualMileage', mileage);
        fetchSimulationVehicleDetailsIfNeededCalculator(globalstate, dispatch, 'annualMileage', mileage, settings);
    }
    function onChangeDeposit(deposit, settings) {
        dispatch(setCalculatorCriteriaDeposit(deposit));
        fetchCriteriaOnParameterChangeIfNeeded(globalstate, dispatch, 'deposit', deposit);
        fetchSimulationVehicleDetailsIfNeededCalculator(globalstate, dispatch, 'deposit', deposit, settings);
    }
    function onChangeCustomer(customer, settings) {
        dispatch(setCalculatorCriteriaCustomer(customer));
        fetchSimulationVehicleDetailsIfNeededCalculator(globalstate, dispatch, 'customer', customer, settings);
    }

    return (
        <CalculatorCriteria
            onChangeProduct={onChangeProduct}
            onChangeDuration={onChangeDuration}
            onChangeMileage={onChangeMileage}
            onChangeDeposit={onChangeDeposit}
            onChangeService={onChangeService}
            onChangeCustomer={onChangeCustomer}
            onUpdate={props.onUpdate}
            context={globalstate.testCriteria.context}
            settings={globalstate.settings}
            parameters={globalstate.calculator.parameters}
            contextCriteria={globalstate.calculator.contextCriteria}
            svcMap={globalstate.calculator.svcMap}
            responseCriteria={globalstate.calculator.responseCriteria}
            responseOffers={globalstate.calculator.responseOffers}
        />
    );
}
